import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "358",
  height: "192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "stage-home",
        x1: "37.451%",
        x2: "168.138%",
        y1: "46.615%",
        y2: "105.455%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#FEFEFD",
          "stop-opacity": ".25"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#FEFEFD"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#stage-home)",
      d: "M124.1 178C148 103.8 217.7 50 299.7 50c20.4 0 40.1 3.3 58.5 9.5V7.3C339.3 2.5 319.7 0 299.7 0c-62.6 0-121.5 24.4-165.8 68.7C103.2 99.3 82.1 137 72 178z",
      transform: "matrix(1 0 0 -1 0 178)"
    }, null, -1)
  ])))
}
export default { render: render }